import React from 'react';
import OperationsSession from '../../Operations/OperationsSession';
import DashboardSession from '../../Dashboard/DashboardSession';

interface SessionContext {
  operations: OperationsSession;
  dashboard: DashboardSession;
}

const SessionContext = React.createContext<SessionContext>({
  operations: {} as OperationsSession,
  dashboard: {} as DashboardSession,
});

export default SessionContext;
